<template>
    <button class="button-search"
            v-on="$listeners"><span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21.581 21.485">
                <g id="Group_7" data-name="Group 7" transform="translate(0.4 0.4)">
                    <path id="Path_4527" data-name="Path 4527" d="M7.913,15.825a7.913,7.913,0,1,1,7.913-7.913A7.92,7.92,0,0,1,7.913,15.825ZM7.913.7a7.209,7.209,0,1,0,7.209,7.209A7.219,7.219,0,0,0,7.913.7Z" transform="translate(0)" fill="#1e1e1e" stroke="#1e1e1e" stroke-width="0.8"/>
                    <path id="Path_4528" data-name="Path 4528" d="M38.053,38.412a.36.36,0,0,1-.25-.1l-.7-.7a.351.351,0,0,1,.5-.5l.7.7a.35.35,0,0,1,0,.5A.346.346,0,0,1,38.053,38.412Z" transform="translate(-23.986 -23.993)" fill="#1e1e1e" stroke="#1e1e1e" stroke-width="0.8"/>
                    <path id="Path_4529" data-name="Path 4529" d="M42.332,44.155h-.144L36.47,38.437,38.707,36.2l5.718,5.718v.144A2.093,2.093,0,0,1,42.332,44.155Zm-4.871-5.718,5.011,5.008A1.4,1.4,0,0,0,43.718,42.2l-5.011-5.008Z" transform="translate(-23.644 -23.469)" fill="#1e1e1e" stroke="#1e1e1e" stroke-width="0.8"/>
                </g>
            </svg></span>Szukaj</button>
</template>

<script>
    export default {
        name: "ButtonSearch",
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/mixins/breakpoint";

    .button-search {
        margin: 0 0 0 0;
        border: 0 none;
        background-color: #efefef;
        color: #212121;
        padding: 0;
        font-size: 18px;
        cursor: pointer;
        width: 50%;
        line-height: 75px;
        display: inline-block;

        @include only-mobile-breakpoint() {
            font-size: 13px;
            line-height: 52px;

            > span {
                margin-right: 5px !important;
                svg {
                    height: 13px;
                    width: 13px;
                }
            }
        }

        &:hover {
            background-color: #dfdfdf;
        }

        &.active {
            background-color: #345463;
            color: #ffffff;
        }

        &.active:hover {
            background-color: #143443;
        }

        & span {
            margin-right: 20px;
        }
        & div {
            display: inline-block;
            background-color: #942E00;
            float: right;
            font-size: 14px;
            padding: 0 20px;
            color: white;
        }
    }

</style>